import { Subject } from "rxjs";

export interface EventBusType {
  type: EventBusName;
  payload?: any;
}

export enum EventBusName {
  //Token
  EXPIRE_TOKEN = "EXPIRE_TOKEN",
  REDIRECT_SSO = "REDIRECT_SSO",
  REDIRECT_APP = "REDIRECT_APP",
  LOGOUT_APP = "LOGOUT_APP",
  ON_LOGIN = "ON_LOGIN",
  GET_USER_INFO_SUCCESS = "GET_USER_INFO_SUCCESS",
  UPDATE_USER_PROFILE = "UPDATE_USER_PROFILE",
  CHANGE_LANGUAGE = "CHANGE_LANGUAGE",
  // machine
  CREATE_MACHINE = "CREATE_MACHINE",
  UPDATE_MACHINE = "UPDATE_MACHINE",
  ADD_PRODUCT_MAP_ITEM = "ADD_PRODUCT_MAP_ITEM",
  UPDATE_PRODUCT_MAP_ITEM = "UPDATE_PRODUCT_MAP_ITEM",
  UPDATE_PRODUCT_MAP_ITEM2 = "UPDATE_PRODUCT_MAP_ITEM2",

  DELETE_PRODUCT_MAP_ITEM = "DELETE_PRODUCT_MAP_ITEM",
  DELETE_PRODUCT_MAP_ITEM2 = "DELETE_PRODUCT_MAP_ITEM2",

  MACHINE_NETWORK_STATUS = "MACHINE_NETWORK_STATUS",
  SEARCH_PRODUCT = "SEARCH_PRODUCT",
  TOGGLE_ACTIVE = "TOGGLE_ACTIVE",
  UPDATE_PRODUCT = "UPDATE_PRODUCT",
  ADD_BANNER = "ADD_BANNER",
  SELECT_MACHINE_IN_LIST = "SELECT_MACHINE_IN_LIST",
  TOGGLE_MOTOR = "TOGGLE_MOTOR",
  // Report
  REPORT_SALES_SEARCH = "REPORT_SALES_SEARCH",
  //
  NEW_NOTIFICATION = "NEW_NOTIFICATION",
  READ_NOTIFICATION = "READ_NOTIFICATION",
  UPDATE_USER_INFO = "UPDATE_USER_INFO",
  RENEW_TOKEN = "RENEW_TOKEN",
  REAL_TIME_NEW_NOTIFICATION = "REAL_TIME_NEW_NOTIFICATION",
  READ_SINGLE_NOTI = "READ_SINGLE_NOTI",
  READ_ALL_NOTI = "READ_ALL_NOTI",

  REAL_TIME_NEW_TASK_NOTIFICATION = "REAL_TIME_NEW_NOTIFICATION",

  //
  FORBIDDEN_REQUEST = "FORBIDDEN_REQUEST",

  //EMPLOYEES
  UPDATE_EMPLOYEES = "UPDATE_EMPLOYEES",
  ADD_EMPLOYEES = "ADD_EMPLOYEES",

  // mobile app
  NAVIGATE_HOME = "NAVIGATE_HOME",
  ERROR = "ERROR",
  ADD_ADS = "ADD_ADS",
}
export default class EventBus {
  private static instance: EventBus;
  private eventSubject = new Subject<EventBusType>();

  static getInstance(): EventBus {
    if (!EventBus.instance) {
      EventBus.instance = new EventBus();
    }
    return EventBus.instance;
  }

  get events() {
    return this.eventSubject.asObservable();
  }

  post(event: EventBusType) {
    console.log("Send event :" , event)
    this.eventSubject.next(event);
  }
}
